import { isPreviewBuild } from 'components/common/previewEnv';
import { APP_DOMAIN } from 'services/constants';
import Cookie from 'services/Cookie';

/** Extract company slug from `{slug}.{appDomain}`; empty string on apex or unrelated hosts. */
export const parseSubdomainFromHostname = (hostname, appDomain = APP_DOMAIN) => {
  if (!hostname || !appDomain) {
    return '';
  }
  if (hostname === appDomain) {
    return '';
  }
  const suffix = `.${appDomain}`;
  if (hostname.endsWith(suffix)) {
    return hostname.slice(0, -suffix.length) || '';
  }
  return '';
};

export default () => {
  // Preview hosts have no company subdomain in the URL; company comes from the cookie.
  if (isPreviewBuild()) {
    return Cookie.get('company')?.subDomain || '';
  }

  return parseSubdomainFromHostname(window.location.hostname);
};
